import { BREAKPOINTS } from '@/js/lib/constants';
import Swiper from 'swiper';
import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

const elements = document.querySelectorAll<HTMLElement>('.js-card-carousel');

function initCarousel(parent: HTMLElement) {
  const carouselEl = parent.querySelector<HTMLElement>('.swiper');
  const carouselIndex = parent.querySelector<HTMLElement>(
    '.card-carousel__index'
  );
  const prevEl = parent.querySelector<HTMLButtonElement>(
    '.card-carousel__button--prev'
  );
  const nextEl = parent.querySelector<HTMLButtonElement>(
    '.card-carousel__button--next'
  );

  return new Swiper(carouselEl, {
    modules: [Navigation, Pagination, Mousewheel, Keyboard],
    slidesPerView: 1.2,
    spaceBetween: 16,
    mousewheel: true,
    keyboard: true,
    navigation: {
      nextEl,
      prevEl,
    },
    pagination: {
      el: carouselIndex,
      type: 'custom',
      renderCustom: (_, current, total) => `${current} ― ${total}`,
    },
    breakpoints: {
      [BREAKPOINTS.lg]: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
  });
}
elements.forEach(initCarousel);
